// components/ui/ThemeToggle.tsx — Day/Night pill matching reference .mode-toggle

import { useAppStore } from '@/store';
import styles from './ThemeToggle.module.css';

export function ThemeToggle() {
  const theme    = useAppStore((s) => s.theme);
  const setTheme = useAppStore((s) => s.setTheme);

  const isNight = (['night', 'dark'] as string[]).includes(theme);

  return (
    /* Two-button pill identical to reference .mode-toggle */
    <div className={styles.pill} role="group" aria-label="Colour mode">
      <button
        type="button"
        className={`${styles.btn} ${isNight ? styles.active : ''}`}
        onClick={() => setTheme('night')}
        aria-pressed={isNight}
        aria-label="Night mode"
      >
        Night
      </button>
      <button
        type="button"
        className={`${styles.btn} ${!isNight ? styles.active : ''}`}
        onClick={() => setTheme('day')}
        aria-pressed={!isNight}
        aria-label="Day mode"
      >
        Day
      </button>
    </div>
  );
}
